import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ManageHistoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"manage_history"}/>
}
